import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import NotificationsFeed from "@/components/NotificationsFeed";
import ChatPanel from "@/components/ChatPanel";
import Dashboard from "@/pages/Dashboard";
import TruckDetail from "@/pages/TruckDetail";
import DriversPage from "@/pages/Drivers";
import CalendarPage from "@/pages/Calendar";
import ClaimsPage from "@/pages/Claims";
import ActivityPage from "@/pages/Activity";
import AttributionPage from "@/pages/Attribution";
import DocumentsPage from "@/pages/Documents";
import PrimesPage from "@/pages/Primes";
import BudgetPage from "@/pages/Budget";
import ConsommationPage from "@/pages/Consommation";
import PlanVaguePage from "@/pages/PlanVague";
import NotesPage from "@/pages/Notes";
import AmendesPage from "@/pages/Amendes";
import FleetMapPage from "@/pages/FleetMap";
import LoginPage from "@/pages/Login";
import ResetPasswordPage from "@/pages/ResetPassword";
import UsersPage from "@/pages/Users";
import TelepeagesPage from "@/pages/Telepeages";
import { AuthProvider, useAuth } from "@/lib/auth";

function ProtectedShell({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-zinc-500 mono uppercase tracking-widest text-xs">
        Chargement…
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  return (
    <>
      <Header />
      {children}
      <NotificationsFeed />
      <ChatPanel />
    </>
  );
}

function AdminOnly({ children }) {
  const { user } = useAuth();
  if (!user || user.role !== "admin") {
    return <Navigate to="/" replace />;
  }
  return children;
}

function App() {
  return (
    <AuthProvider>
      <div className="App min-h-screen bg-[#FAFAFA]">
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route
              path="/"
              element={
                <ProtectedShell>
                  <Dashboard />
                </ProtectedShell>
              }
            />
            <Route
              path="/trucks/:id"
              element={
                <ProtectedShell>
                  <TruckDetail />
                </ProtectedShell>
              }
            />
            <Route
              path="/chauffeurs"
              element={
                <ProtectedShell>
                  <DriversPage />
                </ProtectedShell>
              }
            />
            <Route
              path="/calendrier"
              element={
                <ProtectedShell>
                  <CalendarPage />
                </ProtectedShell>
              }
            />
            <Route
              path="/sinistres"
              element={
                <ProtectedShell>
                  <ClaimsPage />
                </ProtectedShell>
              }
            />
            <Route
              path="/attribution"
              element={
                <ProtectedShell>
                  <AttributionPage />
                </ProtectedShell>
              }
            />
            <Route
              path="/documents"
              element={
                <ProtectedShell>
                  <DocumentsPage />
                </ProtectedShell>
              }
            />
            <Route
              path="/primes"
              element={
                <ProtectedShell>
                  <PrimesPage />
                </ProtectedShell>
              }
            />
            <Route
              path="/budget"
              element={
                <ProtectedShell>
                  <BudgetPage />
                </ProtectedShell>
              }
            />
            <Route
              path="/consommation"
              element={
                <ProtectedShell>
                  <ConsommationPage />
                </ProtectedShell>
              }
            />
            <Route
              path="/plan-vague"
              element={
                <ProtectedShell>
                  <PlanVaguePage />
                </ProtectedShell>
              }
            />
            <Route
              path="/notes"
              element={
                <ProtectedShell>
                  <NotesPage />
                </ProtectedShell>
              }
            />
            <Route
              path="/amendes"
              element={
                <ProtectedShell>
                  <AmendesPage />
                </ProtectedShell>
              }
            />
            <Route
              path="/telepeages"
              element={
                <ProtectedShell>
                  <TelepeagesPage />
                </ProtectedShell>
              }
            />
            <Route
              path="/carte"
              element={
                <ProtectedShell>
                  <FleetMapPage />
                </ProtectedShell>
              }
            />
            <Route
              path="/journal"
              element={
                <ProtectedShell>
                  <ActivityPage />
                </ProtectedShell>
              }
            />
            <Route
              path="/utilisateurs"
              element={
                <ProtectedShell>
                  <AdminOnly>
                    <UsersPage />
                  </AdminOnly>
                </ProtectedShell>
              }
            />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="top-right"
          toastOptions={{
            style: { borderRadius: 0, border: "1px solid #09090B" },
          }}
        />
      </div>
    </AuthProvider>
  );
}

export default App;
